import { initializeSC, updateAuthority, updatePresalePrice, updatePriceFeed, withdrawIncome, } from '../../chains/svm/api';
export async function initSvmGlobalState(params, deps) {
    await initializeSC(params.presalePrice, params.solPriceFeed, params.solAccountRay, params.caiAccountRay, params.caiMint);
    await deps.refreshSvmGlobalState();
    deps.toast.success('Global state initialized');
}
export async function updateSvmAuthority(authority, deps) {
    await updateAuthority(authority);
    await deps.refreshSvmGlobalState();
    deps.toast.success('Authority updated');
}
export async function updateSvmPresalePrice(presalePrice, deps) {
    await updatePresalePrice(presalePrice);
    await deps.refreshSvmGlobalState();
    deps.toast.success('Presale price updated');
}
export async function updateSvmPriceFeed(params, deps) {
    await updatePriceFeed(params.solPriceFeed, params.caiMint, params.caiPriceFeed);
    await deps.refreshSvmGlobalState();
    deps.toast.success('Price feed updated');
}
export async function withdrawSvmIncome(deps) {
    await withdrawIncome();
    deps.toast.success('Income withdrawn');
}
